import { render, staticRenderFns } from "./FaqTagsTable.vue?vue&type=template&id=a040ebee"
import script from "./FaqTagsTable.vue?vue&type=script&lang=js"
export * from "./FaqTagsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports